import { Images } from '@/assets/images';
import { REGEX } from '@/constant';
import { cn } from '@/utils';

import { includes, range } from 'ramda';

import { CheckboxType, FormConfig } from '../define-document-write.type';

const initializeValue = {
	visaPayment: '',
	notarizationCosts: '',
	overtimePay: '',
	comment: '',
	officials: [],
	workplace: [],
	salaryAccount: [],
	depositSupport: [],
	nameSupport: '',
	passportDeprivation: [],
	deprivationOrther: '',
	employerTreatment: [],
	vistimsViolation: [],
	//
	beforeEntry1: '',
	beforeEntry2: '',
	beforeEntry3: '',
	beforeEntry4: '',
	beforeEntry5: '',
	beforeEntry6: '',
	afterEntry1: '',
	subAfterEntry1: '',
	afterEntry2: '',
	subAfterEntry2: '',
	afterEntry3: '',
	afterEntry4: '',
	afterEntry5: '',
	afterEntry6: '',
	afterEntry7: '',
	afterEntry8: '',
	afterEntry9: '',
	afterEntry10: '',
	moneyPaid1: '',
	moneyPaid2: '',
	other1: '',
	other2: '',
	times: '',
	subjectByEmployer: [],
	suggestion: '',
	thief: '',
};

type IValues = typeof initializeValue;
// ARF_06
export const FORM_HUMAN_TRAFFICKING_CONFIG: FormConfig<IValues> = {
	initializeValue,
	title: '인신매매 피해 식별지표',
	pages: [
		{
			background: {
				src: Images.formHumanTraffickingPage1Highlight,
				className: 'template',
				dataSource: Images.formHumanTraffickingPage1,
			},
			textAreas: [
				(values, index) => ({
					name: 'moneyPaid1',
					maxHeight: 20,
					maxLength: 7,
					containerClassName: cn(
						'absolute top-[206px] left-[77.9%] w-[95px]',
						includes('0', values?.beforeEntry1) && 'cursor-pointer'
					),
					className: 'text-[13px]',
					disabled: !includes('0', values?.beforeEntry1),
					regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
				}),
				(values, index) => ({
					name: 'moneyPaid2',
					maxHeight: 20,
					maxLength: 7,
					containerClassName: cn(
						'absolute top-[257px] left-[77.9%] w-[95px]',
						includes('0', values?.beforeEntry2) && 'cursor-pointer'
					),
					className: 'text-[13px]',
					disabled: !includes('0', values?.beforeEntry2),
					regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
				}),
				(values, index) => ({
					name: 'other1',
					maxHeight: 20,
					maxLength: 6,
					containerClassName: cn(
						'absolute top-[546px] left-[81.6%] w-[55px]',
						includes('2', values?.subAfterEntry1) && 'cursor-pointer'
					),
					className: 'text-[11px]',
					disabled: !includes('2', values?.subAfterEntry1),
					regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
				}),
				(values, index) => ({
					name: 'other2',
					maxHeight: 20,
					maxLength: 12,
					containerClassName: cn(
						'absolute top-[625px] left-[75%] w-[105px]',
						includes('3', values?.subAfterEntry2) && 'cursor-pointer'
					),
					className: 'text-[11px]',
					disabled: !includes('3', values?.subAfterEntry2),
					regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
				}),
				(values, index) => ({
					name: 'times',
					maxHeight: 20,
					maxLength: 2,
					containerClassName: 'absolute top-[653px] left-[74.7%] w-[22px]',
					className: 'text-[13px]',
					regex: REGEX.ALLOW_NUMBER,
					disabled: !includes('1', values?.afterEntry3),
				}),
				{
					name: 'suggestion',
					maxHeight: 110,
					maxLength: 110,
					containerClassName: 'absolute top-[901px] left-[69%] w-[166px]',
					className: 'text-[11px]',
					regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
				},
			],
			checkboxes: [
				{
					name: 'beforeEntry1',
					options: ['0', '1'],
					classNames: [
						'absolute top-[190px] right-[229px] w-3 !h-3', // 0
						'absolute top-[190px] right-[149px] w-3 !h-3', // 1
					],
					iconType: 'square',
					getResetKey: (value: string) => {
						return ['moneyPaid1'];
					},
				},
				{
					name: 'beforeEntry2',
					options: ['0', '1'],
					classNames: [
						'absolute top-[242px] right-[229px] w-3 !h-3', // 0
						'absolute top-[242px] right-[149px] w-3 !h-3', // 1
					],
					iconType: 'square',
					getResetKey: (value: string) => {
						return ['moneyPaid2'];
					},
				},
				{
					name: 'beforeEntry3',
					options: range(1, 5).map(String),
					classNames: [
						'absolute top-[291px] right-[229px] w-3 !h-3', // 1
						'absolute top-[312px] right-[229px] w-3 !h-3', // 2
						'absolute top-[333px] right-[229px] w-3 !h-3', // 3
						'absolute top-[354px] right-[229px] w-3 !h-3', // 4
					],
					iconType: 'square',
				},
				{
					name: 'beforeEntry4',
					options: range(1, 4).map(String),
					classNames: [
						'absolute top-[380px] right-[229px] w-3 !h-3', // 1
						'absolute top-[401px] right-[229px] w-3 !h-3', // 2
						'absolute top-[422px] right-[229px] w-3 !h-3', // 3
					],
					iconType: 'square',
				},
				{
					name: 'beforeEntry5',
					options: range(1, 3).map(String),
					classNames: [
						'absolute top-[459px] right-[229px] w-3 !h-3', // 1
						'absolute top-[459px] right-[149px] w-3 !h-3', // 2
					],
					iconType: 'square',
				},
				{
					name: 'beforeEntry6',
					options: range(1, 3).map(String),
					classNames: [
						'absolute top-[498px] right-[229px] w-3 !h-3', // 1
						'absolute top-[498px] right-[149px] w-3 !h-3', // 2
					],
					iconType: 'square',
				},
				{
					name: 'afterEntry1',
					options: range(1, 3).map(String),
					classNames: [
						'absolute top-[526px] right-[229px] w-3 !h-3', // 1
						'absolute top-[526px] right-[149px] w-3 !h-3', // 2
					],
					iconType: 'square',
					getResetKey: (value: string) => {
						return ['other1', 'subAfterEntry1'];
					},
				},
				(values, index) => {
					return {
						name: 'subAfterEntry1',
						options: range(1, 3).map(String),
						classNames: [
							`absolute top-[551px] right-[224px] w-3 !h-3 ${includes('2', values?.afterEntry1) ? 'cursor-default' : ''}`, // 3
							`absolute top-[551px] right-[175px] w-3 !h-3 ${includes('2', values?.afterEntry1) ? 'cursor-default' : ''}`, // 4`,
						],
						iconType: 'square',
						getResetKey: (value: string) => {
							return ['other1'];
						},
						disabled: !includes('1', values?.afterEntry1),
					};
				},
				{
					name: 'afterEntry2',
					options: range(1, 3).map(String),
					classNames: [
						'absolute top-[578px] right-[229px] w-3 !h-3', // 1
						'absolute top-[578px] right-[149px] w-3 !h-3', // 2
					],
					iconType: 'square',
					getResetKey: (value: string) => {
						return ['other2', 'subAfterEntry2'];
					},
				},
				(values, index) => {
					return {
						name: 'subAfterEntry2',
						options: range(1, 4).map(String),
						classNames: [
							`absolute top-[603px] right-[224px] w-3 !h-3 ${includes('2', values?.afterEntry2) ? 'cursor-default' : ''}`, // 3
							`absolute top-[603px] right-[161px] w-3 !h-3 ${includes('2', values?.afterEntry2) ? 'cursor-default' : ''}`, // 4`,
							`absolute top-[629px] right-[229px] w-3 !h-3 ${includes('2', values?.afterEntry2) ? 'cursor-default' : ''}`, // 5`,
						],
						iconType: 'square',
						getResetKey: (value: string) => {
							return ['other2'];
						},
						disabled: !includes('1', values?.afterEntry2),
					};
				},
				{
					name: 'afterEntry3',
					options: range(1, 3).map(String),
					classNames: [
						'absolute top-[657px] right-[229px] w-3 !h-3', // 1
						'absolute top-[657px] right-[140px] w-3 !h-3', // 2
					],
					iconType: 'square',
					getResetKey: (value: string) => {
						return ['times'];
					},
				},
				{
					name: 'afterEntry4',
					options: range(1, 3).map(String),
					classNames: [
						'absolute top-[687px] right-[229px] w-3 !h-3', // 1
						'absolute top-[687px] right-[149px] w-3 !h-3', // 2
					],
					iconType: 'square',
				},
				{
					name: 'afterEntry5',
					options: range(1, 3).map(String),
					classNames: [
						'absolute top-[724px] right-[229px] w-3 !h-3', // 1
						'absolute top-[724px] right-[149px] w-3 !h-3', // 2
					],
					iconType: 'square',
				},
				{
					name: 'afterEntry6',
					options: range(1, 3).map(String),
					classNames: [
						'absolute top-[764px] right-[229px] w-3 !h-3', // 1
						'absolute top-[764px] right-[149px] w-3 !h-3', // 2
					],
					iconType: 'square',
				},
				{
					type: CheckboxType.MULTIPLE,
					name: 'subjectByEmployer',
					options: range(1, 4).map(String),
					classNames: [
						'absolute top-[764px] right-[535px] w-3 !h-3', // 1
						'absolute top-[764px] right-[465px] w-3 !h-3', // 2
						'absolute top-[764px] right-[395px] w-3 !h-3', // 3
					],
					iconType: 'square',
				},
				{
					name: 'afterEntry7',
					options: range(1, 3).map(String),
					classNames: [
						'absolute top-[792px] right-[229px] w-3 !h-3', // 1
						'absolute top-[792px] right-[149px] w-3 !h-3', // 2
					],
					iconType: 'square',
				},
				{
					name: 'afterEntry8',
					options: range(1, 3).map(String),
					classNames: [
						'absolute top-[821px] right-[229px] w-3 !h-3', // 1
						'absolute top-[821px] right-[149px] w-3 !h-3', // 2
					],
					iconType: 'square',
				},
				{
					name: 'afterEntry9',
					options: range(1, 3).map(String),
					classNames: [
						'absolute top-[850px] right-[229px] w-3 !h-3', // 1
						'absolute top-[850px] right-[149px] w-3 !h-3', // 2
					],
					iconType: 'square',
				},
				{
					name: 'afterEntry10',
					options: range(1, 3).map(String),
					classNames: [
						'absolute top-[879px] right-[229px] w-3 !h-3', // 1
						'absolute top-[879px] right-[149px] w-3 !h-3', // 2
					],
					iconType: 'square',
				},
			],
		},
		{
			background: {
				src: Images.formHumanTraffickingPage2Highlight,
				className: 'template',
				dataSource: Images.formHumanTraffickingPage2,
			},
			textAreas: [
				(values, index) => ({
					name: 'moneyPaid1',
					maxHeight: 20,
					maxLength: 7,
					containerClassName: cn(
						'absolute top-[254px] left-[79.3%] w-[75px]',
						includes('0', values?.beforeEntry1) && 'cursor-pointer'
					),
					className: 'text-[13px]',
					disabled: !includes('0', values?.beforeEntry1),
					regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
				}),
				(values, index) => ({
					name: 'moneyPaid2',
					maxHeight: 20,
					maxLength: 7,
					containerClassName: cn(
						'absolute top-[347px] left-[79.3%] w-[80px]',
						includes('0', values?.beforeEntry2) && 'cursor-pointer'
					),
					className: 'text-[13px]',
					disabled: !includes('0', values?.beforeEntry2),
					regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
				}),
				(values, index) => ({
					name: 'other1',
					maxHeight: 30,
					maxLength: 6,
					containerClassName: cn(
						'absolute top-[771px] left-[82.1%] w-[41px]',
						includes('2', values?.subAfterEntry1) && 'cursor-pointer'
					),
					className: 'text-[10px]',
					disabled: !includes('2', values?.subAfterEntry1),
					regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
				}),
				(values, index) => ({
					name: 'other2',
					maxHeight: 20,
					maxLength: 12,
					containerClassName: cn(
						'absolute top-[859px] left-[74%] w-[105px]',
						includes('3', values?.subAfterEntry2) && 'cursor-pointer'
					),
					className: 'text-[11px]',
					disabled: !includes('3', values?.subAfterEntry2),
					regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
				}),
				(values, index) => ({
					name: 'times',
					maxHeight: 20,
					maxLength: 2,
					containerClassName: 'absolute top-[887px] left-[82.7%] w-[22px]',
					className: 'text-[13px]',
					regex: REGEX.ALLOW_NUMBER,
					disabled: !includes('1', values?.afterEntry3),
				}),
				{
					name: 'thief',
					maxHeight: 20,
					maxLength: 5,
					containerClassName: 'absolute top-[836px] left-[369px] w-[54px]',
					className: 'text-[13px]',
					regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
				},
			],
			checkboxes: [
				{
					name: 'beforeEntry1',
					options: ['0', '1'],
					classNames: [
						'absolute top-[217px] right-[229px] w-3 !h-3', // 0
						'absolute top-[217px] right-[140px] w-3 !h-3', // 1
					],
					iconType: 'square',
					getResetKey: (value: string) => {
						return ['moneyPaid1'];
					},
				},
				{
					name: 'beforeEntry2',
					options: ['0', '1'],
					classNames: [
						'absolute top-[309px] right-[229px] w-3 !h-3', // 0
						'absolute top-[309px] right-[140px] w-3 !h-3', // 1
					],
					iconType: 'square',
					getResetKey: (value: string) => {
						return ['moneyPaid2'];
					},
				},
				{
					name: 'beforeEntry3',
					options: range(1, 5).map(String),
					classNames: [
						'absolute top-[381px] right-[229px] w-3 !h-3', // 1
						'absolute top-[423px] right-[229px] w-3 !h-3', // 2
						'absolute top-[443px] right-[229px] w-3 !h-3', // 3
						'absolute top-[464px] right-[229px] w-3 !h-3', // 4
					],
					iconType: 'square',
				},
				{
					name: 'beforeEntry4',
					options: range(1, 4).map(String),
					classNames: [
						'absolute top-[484px] right-[229px] w-3 !h-3', // 1
						'absolute top-[505px] right-[229px] w-3 !h-3', // 2
						'absolute top-[546px] right-[229px] w-3 !h-3', // 3
					],
					iconType: 'square',
				},
				{
					name: 'beforeEntry5',
					options: range(1, 3).map(String),
					classNames: [
						'absolute top-[598px] right-[229px] w-3 !h-3', // 1
						'absolute top-[598px] right-[140px] w-3 !h-3', // 2
					],
					iconType: 'square',
				},
				{
					name: 'beforeEntry6',
					options: range(1, 3).map(String),
					classNames: [
						'absolute top-[673px] right-[229px] w-3 !h-3', // 1
						'absolute top-[673px] right-[140px] w-3 !h-3', // 2
					],
					iconType: 'square',
				},
				{
					name: 'afterEntry1',
					options: range(1, 3).map(String),
					classNames: [
						'absolute top-[717px] right-[229px] w-3 !h-3', // 1
						'absolute top-[717px] right-[140px] w-3 !h-3', // 2
					],
					iconType: 'square',
					getResetKey: (value: string) => {
						return ['other1', 'subAfterEntry1'];
					},
				},
				(values, index) => {
					return {
						name: 'subAfterEntry1',
						options: range(1, 3).map(String),
						classNames: [
							`absolute top-[738px] right-[224px] w-3 !h-3 ${includes('2', values?.afterEntry1) ? 'cursor-default' : ''}`, // 3
							`absolute top-[738px] right-[156px] w-3 !h-3 ${includes('2', values?.afterEntry1) ? 'cursor-default' : ''}`, // 4`,
						],
						iconType: 'square',
						getResetKey: (value: string) => {
							return ['other1'];
						},
						disabled: !includes('1', values?.afterEntry1),
					};
				},
				{
					name: 'afterEntry2',
					options: range(1, 3).map(String),
					classNames: [
						'absolute top-[799px] right-[229px] w-3 !h-3', // 1
						'absolute top-[799px] right-[140px] w-3 !h-3', // 2
					],
					iconType: 'square',
					getResetKey: (value: string) => {
						return ['other2', 'subAfterEntry2'];
					},
				},
				(values, index) => {
					return {
						name: 'subAfterEntry2',
						options: range(1, 4).map(String),
						classNames: [
							`absolute top-[820px] right-[229px] w-3 !h-3 ${includes('2', values?.afterEntry2) ? 'cursor-default' : ''}`, // 3
							`absolute top-[820px] right-[153px] w-3 !h-3 ${includes('2', values?.afterEntry2) ? 'cursor-default' : ''}`, // 4`,
							`absolute top-[841px] right-[95px] w-3 !h-3 ${includes('2', values?.afterEntry2) ? 'cursor-default' : ''}`, // 5`,
						],
						iconType: 'square',
						getResetKey: (value: string) => {
							return ['other2'];
						},
						disabled: !includes('1', values?.afterEntry2),
					};
				},
				{
					name: 'afterEntry3',
					options: range(1, 3).map(String),
					classNames: [
						'absolute top-[892px] right-[229px] w-3 !h-3', // 1
						'absolute top-[913px] right-[229px] w-3 !h-3', // 2
					],
					iconType: 'square',
					getResetKey: (value: string) => {
						return ['times'];
					},
				},
				{
					name: 'afterEntry4',
					options: range(1, 3).map(String),
					classNames: [
						'absolute top-[946px] right-[229px] w-3 !h-3', // 1
						'absolute top-[946px] right-[140px] w-3 !h-3', // 2
					],
					iconType: 'square',
				},
				{
					name: 'afterEntry5',
					options: range(1, 3).map(String),
					classNames: [
						'absolute top-[998px] right-[229px] w-3 !h-3', // 1
						'absolute top-[998px] right-[140px] w-3 !h-3', // 2
					],
					iconType: 'square',
				},
			],
		},
		{
			background: {
				src: Images.formHumanTraffickingPage3Highlight,
				className: 'template',
				dataSource: Images.formHumanTraffickingPage3,
			},
			textAreas: [
				{
					name: 'suggestion',
					maxHeight: 148,
					maxLength: 110,
					containerClassName: 'absolute top-[278px] left-[69%] w-[166px]',
					className: 'text-[11px]',
					regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
				},
			],
			checkboxes: [
				{
					name: 'afterEntry6',
					options: range(1, 3).map(String),
					classNames: [
						'absolute top-[93px] right-[229px] w-3 !h-3', // 1
						'absolute top-[93px] right-[140px] w-3 !h-3', // 2
					],
					iconType: 'square',
				},
				{
					type: CheckboxType.MULTIPLE,
					name: 'subjectByEmployer',
					options: range(1, 4).map(String),
					classNames: [
						'absolute top-[83px] right-[437px] w-3 !h-3', // 1
						'absolute top-[83px] right-[302px] w-3 !h-3', // 2
						'absolute top-[104px] right-[516px] w-3 !h-3', // 3
					],
					iconType: 'square',
				},
				{
					name: 'afterEntry7',
					options: range(1, 3).map(String),
					classNames: [
						'absolute top-[127px] right-[229px] w-3 !h-3', // 1
						'absolute top-[127px] right-[140px] w-3 !h-3', // 2
					],
					iconType: 'square',
				},
				{
					name: 'afterEntry8',
					options: range(1, 3).map(String),
					classNames: [
						'absolute top-[154px] right-[229px] w-3 !h-3', // 1
						'absolute top-[154px] right-[140px] w-3 !h-3', // 2
					],
					iconType: 'square',
				},
				{
					name: 'afterEntry9',
					options: range(1, 3).map(String),
					classNames: [
						'absolute top-[188px] right-[229px] w-3 !h-3', // 1
						'absolute top-[188px] right-[140px] w-3 !h-3', // 2
					],
					iconType: 'square',
				},
				{
					name: 'afterEntry10',
					options: range(1, 3).map(String),
					classNames: [
						'absolute top-[239px] right-[229px] w-3 !h-3', // 1
						'absolute top-[239px] right-[140px] w-3 !h-3', // 2
					],
					iconType: 'square',
				},
			],
		},
	],
};
